import { ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { ObjectSerializer } from "../DiscoveryEngine.TS/Serialization/ObjectSerializer";

export class ResultDto implements ObjectSerializer {

	public Succeeded: boolean;
	public Message: string;

	constructor() {
		this.Succeeded = false;
		this.Message = "";
	}

	public get HasMessage(): boolean {
		return !!this.Message;
	}

	public Write(obj: any, context: any): void {
		obj.result = {};
		obj = obj.result;

		obj.succeeded = ValueEncoder.EncodeBoolean(this.Succeeded);

		if (this.HasMessage)
			obj.message = this.Message;
	}

	public Read(obj: any, context: any): void {
		if (!obj.result)
			throw new Error();
		obj = obj.result;

		if (obj.succeeded !== undefined)
			this.Succeeded = ValueEncoder.DecodeBoolean(obj.succeeded);

		if (obj.message !== undefined)
			this.Message = obj.message;
	}

}
